import React from 'react';
import { graphql } from 'gatsby';
import { Quote as QuoteComponent } from '../../../quote/Quote';

export const Quote = ({ data, ...rest }) => (
  <QuoteComponent {...data} {...rest} />
);

export const QuoteQuery = graphql`
  fragment Quote on UMBRACO_QuoteComponentType {
    text
    centered
    company
    quoteName
    position
  }
`;
